import { render, staticRenderFns } from "./subcategoriaproductoAdd.vue?vue&type=template&id=0a0cdd64&scoped=true&"
import script from "./subcategoriaproductoAdd.vue?vue&type=script&lang=js&"
export * from "./subcategoriaproductoAdd.vue?vue&type=script&lang=js&"
import style0 from "./subcategoriaproductoAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./subcategoriaproductoAdd.vue?vue&type=style&index=1&id=0a0cdd64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cdd64",
  null
  
)

export default component.exports